import {Stack, Typography} from '@mui/material';
import {Row, StyledCard} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {RequestCardProps} from './types';
import {RefundVariantEnum} from '../../constants/refundVariantEnum';

const {previewTitle, additionalDocsTitle, description, modality, patient} =
	translations['pt-br'].privateFlow.refund.conferencePage.requestCard;

export const RequestCard = ({variant, data}: RequestCardProps) => {
	const isPreview = variant === RefundVariantEnum.PREVIEW;
	const {isMobile} = useMediaQueries();

	const isMobilePreview = isPreview && isMobile;
	const isLaptopPreview = isPreview && !isMobile;

	return (
		<StyledCard.Container>
			<Stack spacing={2}>
				<Stack>
					<Typography variant="subtitle2" color="text.secondary">
						{isPreview ? previewTitle : additionalDocsTitle}
					</Typography>
					<Typography>Nº {data.requestNumber}</Typography>
				</Stack>
				{isMobilePreview ? (
					<Fragment>
						<Row.Simple title={patient} value={data.patientName || ''} />
						<Row.Simple title={modality} value={data.modality || ''} />
					</Fragment>
				) : null}

				{isLaptopPreview ? (
					<Row.Compound
						items={[
							{title: patient, value: data.patientName || ''},
							{title: modality, value: data.modality || ''},
						]}
					/>
				) : null}

				<Stack>
					<Typography variant="body2" color="text.secondary">
						{description}
					</Typography>

					<Typography sx={{overflowWrap: 'break-word'}}>{data.description}</Typography>
				</Stack>
			</Stack>
		</StyledCard.Container>
	);
};
